import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";


export default class GSAvatarLoader
{
    private _mapTextureCache: Map<string, PIXI.Texture> = null;
    
    public static _instance: GSAvatarLoader = null


    public static get i(): GSAvatarLoader
    {
        if ( !this._instance )
        {
            this._instance = new GSAvatarLoader();
        }

        return this._instance;
    }

    private constructor() 
    {
        this._mapTextureCache = new Map<string, PIXI.Texture>();
    }

    public load( url: string, callback: ( texture: PIXI.Texture ) => void ): void
    {
        if ( !( URL as any ).canParse( url ) )
        {
            callback( ServiceLocator.resources[ url ].texture );
        }
        else
        {
            if ( this._mapTextureCache.has( url ) )
            {
                callback( this._mapTextureCache.get( url ) );
            }
            else
            {
                let img: HTMLImageElement = new Image();
                // Importante para evitar problemas de seguridad si el SVG es externo
                img.crossOrigin = "anonymous"; 
                img.onload = () => {
                    // 1. Creamos un canvas físico con el tamaño EXACTO que queremos
                    let canvas = document.createElement( "canvas" );
                    canvas.width = 150;
                    canvas.height = 150;

                    // 2. Dibujamos el SVG en el canvas
                    // Esto convierte los vectores en píxeles (Bitmap)
                    let ctx: CanvasRenderingContext2D = canvas.getContext( "2d" );
                    ctx.drawImage( img, 0, 0, 150, 150 );

                    // 3. Creamos la textura de Pixi desde el Canvas
                    // Un Canvas es, por definición, un Bitmap procesado
                    let svgTexture: PIXI.Texture = PIXI.Texture.from( canvas );
                    callback( svgTexture );
                    //
                    this._mapTextureCache.set( url, svgTexture );

                    ctx = null;
                    canvas = null;
                    img = null; 
                };

                img.src = url;
            }
        }
    }
}